import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const MainLayout = () => {
  // useEffect(() => {
  //   // Add CSS
  //   const link = document.createElement('link');
  //   link.rel = 'stylesheet';
  //   link.href = 'https://fhrwidget-reborn.netlify.app/bundle.css';
  //   document.head.appendChild(link);
    


  //   // Add JavaScript
  //   const script = document.createElement('script');
  //   script.src = 'https://fhrwidget-reborn.netlify.app/bundle.js';
  //   script.async = true;
  //   document.body.appendChild(script);
  //   // Add JavaScript

  //   // Cleanup function
  //   return () => {
  //     document.head.removeChild(link);
  //     document.body.removeChild(script);

  //   };
  // }, []); // Empty dependency array means this runs once on mount

  useEffect(() => {
 
  
    // Add CSS
    const link2 = document.createElement('link');
    link2.rel = 'stylesheet';
    link2.href = 'https://bookingjourney-widget-v3.netlify.app/bundle.css';
    document.head.appendChild(link2);
  
    
    //script is a module so we need to use type="module"
      const script2 = document.createElement('script');
      script2.type = 'module';
      script2.src = 'https://bookingjourney-widget-v3.netlify.app/bundle.js';
      script2.async = true;
      document.body.appendChild(script2);
    

    // Cleanup function
    return () => {
      document.body.removeChild(script2);
      document.head.removeChild(link2);
    };
  }, []);
  return (
    <div className="lil-min-h-screen lil-flex lil-flex-col">
      <Header />
      <main className="lil-flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout; 